/**
 * Основное, то что относится к ядру системы. Модуль для работы с API.
 * @module core
 */

/**
 * Получение версии приложения
 * @returns {Promise} - текущая версия
 * @throws {Error} - ошибка при получении данных
 */
export const getVersion = async () => {
  try {
    const response = await fetch(`/api/clientversion`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение данных конфигурации приложения
 * @returns {Promise} - данные конфигурации
 * @throws {Error} - ошибка при получении данных
 */
export const getConfig = async () => {
  try {
    const response = await fetch("/api/public/siteconfig", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    const defaultConfig = {
      favicon_path: "/favicon.ico",
      logo_path: "/logo-teamtools.svg",
      logo_docs_path: "/pdf-logo-teamtools.png",
      system_name: "teamtools",
      browser_tab_title: "Teamtools",
      messenger_enabled: false,
      messenger_iframe_url: "",
      messenger_client_origin: "",
      messenger_title: "Мессенджер",
    };

    const serverConfig = data.siteConfig || {};

    // Объединяем конфиг по умолчанию с полученными от сервера значениями
    // Сервер перезаписывает дефолтные значения, но только для ненулевых параметров
    const siteConfig = {
      ...defaultConfig,
      ...Object.fromEntries(
        Object.entries(serverConfig).filter(
          ([_, v]) => v !== null && v !== undefined && v !== ""
        )
      ),
      messenger_enabled: Boolean(serverConfig.messenger_enabled),
      messenger_iframe_url:
        serverConfig.messenger_iframe_url || defaultConfig.messenger_iframe_url,
      messenger_client_origin:
        serverConfig.messenger_client_origin ||
        defaultConfig.messenger_client_origin,
      messenger_title: serverConfig.messenger_title || defaultConfig.messenger_title,
      is_red_logo: !serverConfig.system_name,
    };

    return siteConfig;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение статусов всех сотрудников
 * @returns {Promise<Array>} - массив статусов сотрудников
 * @throws {Error} - ошибка при получении данных
 */
export const getEmployeesStatuses = async () => {
  try {
    const response = await fetch("/api/employees/statuses", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении статусов сотрудников. ${data.error}`
      );
    }

    return data.data;
  } catch (error) {
    throw error;
  }
};
